/**
 * Development-only logger
 * Logs are disabled in production builds for better performance
 */

const isDev = process.env.NODE_ENV === 'development';

export const devLog = isDev ? console.log.bind(console) : () => {};
export const devWarn = isDev ? console.warn.bind(console) : () => {};
export const devError = console.error.bind(console); // Always show errors

// Keep console.error/warn available for production errors
// Only devLog is disabled in production
